import { Component, OnInit, Input } from '@angular/core';
import { MqttService } from '../services/mqtt.service';
import { TokenData } from '../services/oauth2-service';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UtilService } from '../services/util.service';
import { FontAwesomeService } from '../services/fontawesome.service';
@Component({
  selector: 'app-menu-superior',
  templateUrl: './menu-superior.component.html',
  styleUrls: ['./menu-superior.component.scss'],
})
export class MenuSuperiorComponent implements OnInit {
  timeConnection;
  fechaCabecera;

  @Input() user: User;
  @Input() title: string;
  @Input() button: boolean;

  activateShowTime: number = 0;
  showTimeDifference: boolean = false;

  constructor(
    public tokenData: TokenData,
    public mqttService: MqttService,
    public storage: Storage,
    public router: Router,
    public utilService: UtilService,
    public faService: FontAwesomeService,
  ) { }

  sub: Subscription;
  ngOnInit() {
    this.tokenData.detectPause();
    this.tokenData.detectResume(this.title);
    this.sub = this.utilService.realtime.subscribe(rt => { rt ? this.fechaCabecera = rt : this.fechaCabecera = null; });
    this.getConfig();
  }

  ngOnDestroy() { }

  closeApp() {
    this.tokenData.stopTimer();
    this.storage.remove("user");
    this.router.navigateByUrl('/login', { replaceUrl: true })
  }

  cambioContrasenha() {
    this.router.navigateByUrl('/cambio-contrasenha', { replaceUrl: true })
  }

  changePingVisibility() {
    this.activateShowTime++;
    if (this.activateShowTime == 5) {
      this.storage.set("showTimeDifference", true);
      this.showTimeDifference = true;
      this.activateShowTime = 0;
    } else {
      if (this.showTimeDifference != false) {
        this.storage.set("showTimeDifference", false);
        this.showTimeDifference = false;
      }
    }
  }

  async getConfig() {
    this.showTimeDifference = await this.storage.get("showTimeDifference");
  }
}
